export default __webpack_public_path__ + "static/media/icons8-synchronize.233a9639.svg";